import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css"; // Import the CSS file
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [schoolLoginID, setSchoolLoginID] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      schoolLoginID: schoolLoginID,
      password: password,
    };

    http: axios
      .post(`${process.env.REACT_APP_API_URL}/auth/login`, payload)
      .then((res) => {
        setLoading(false);
        toast.success("Login Successful!");
        console.log("Login done", res);
        localStorage.setItem("token", JSON.stringify(res.data.token));
        setTimeout(() => {
          navigate(`/erp`);
        }, 1200);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Invalid Credentials. Please try again.", {
          autoClose: 3000,
        });
        console.error("Error while login:", err);
      });
  };

  return (
    <>
      {/* Toast Container for notifications */}
      <ToastContainer />
      <div className="login-container">
        <div className="login-box  mb-2">
          <h2 className="login-title">School Admin Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4 text-start">
              <label htmlFor="exampleInputEmail1" className="form-label">
                <strong>School Id</strong>
              </label>
              <input
                type="text"
                placeholder="Enter School Login Id"
                className="form-control"
                id="exampleInputEmail1"
                onChange={(event) => setSchoolLoginID(event.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="exampleInputPassword1" className="form-label">
                <strong>Password</strong>
              </label>
              <input
                type="password"
                placeholder="Enter Password"
                className="form-control"
                id="exampleInputPassword1"
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>
            <button
              disabled={loading}
              type="submit"
              className="btn btn-primary login-button py-2 px-4 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
            >
              {loading ? "Submitting.." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
